"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var TweekClient_1 = require("./TweekClient");
exports.TweekClient = TweekClient_1.default;
var TweekClientWithFallback_1 = require("./TweekClientWithFallback");
exports.TweekClientWithFallback = TweekClientWithFallback_1.default;
__export(require("./createTweekClient"));
__export(require("./createTweekClientWithFallback"));
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ../../src/TweekClient/index.ts